export function createLinkAndDownloadAsCSV(data, filename) {
    const anchor = document.createElement("a");
  
    anchor.href = `data:text/csv;charset=utf-8,${encodeURIComponent(data)}`;
    anchor.target = "_blank";
    anchor.download = `${filename}.csv`;
    anchor.click();
  }